import { Link } from "react-router-dom";

export const LEGAL_LINKS = [
  ["/contact", "Contact", "contact"],
  ["/terms", "Terms", "terms"],
  ["/privacy-policy", "Privacy", "privacy"],
  ["/refund-policy", "Refunds", "refund"],
  ["/cookie-policy", "Cookies", "cookie"],
  ["/disclaimer", "Disclaimer", "disclaimer"],
  ["/grievance", "Grievance", "grievance"],
];

export default function LegalLinks({ children, className = "" }) {
  return (
    <nav className={`flex flex-wrap items-center justify-center gap-x-5 gap-y-2 ${className}`}>
      {children}
      {LEGAL_LINKS.map(([to, label, id]) => (
        <Link key={to} to={to} className="hover:text-white transition-colors" data-testid={`footer-${id}-link`}>{label}</Link>
      ))}
    </nav>
  );
}
